<!--
 * @Author: tianshuai 1446360207@qq.com
 * @Date: 2024-08-27 13:44:36
 * @LastEditors: tianshuai 1446360207@qq.com
 * @LastEditTime: 2024-10-17 16:18:52
 * @FilePath: \惠宾官网\src\components\rongyu-zizhi.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="zizhi-grid row flex-item-center">
		<div class="swiper w100 h100">
			<swiper class="flex-space-around h100" ref="mySwiper" :options="swiperOptions2">
				<swiper-slide class="zizhi-item h100" v-for="(item,index) in imgList" :key="index">
					<img :src="item.url" class="zizhi-img center-block" >
					<div class="zizhi-title text-center" v-if="item.title">{{item.title}}</div>
				</swiper-slide>
			</swiper>
			<!-- <div class="swiper-pagination" slot="pagination"></div> -->
			<!-- 如果需要导航按钮 -->
			<div class="swiper-button-prev"></div>
			<div class="swiper-button-next"></div>
		</div>
	</div>
</template>
	
<script>
	export default {
		// name:"",
		props: {
			imgList: {
				type: Array,
				default:function(){
					return []
				}
			},
		},
		data(){
			return {
				swiperOptions2: {
					slidesPerView: 1,
					loop: true,
					speed:2000,
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: false
					},
					// pagination: {
					//     el: '.swiper-pagination',
					//     type: 'fraction',
					//     clickable: true
					// },
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				},
			}
		},
		methods:{

		}
	}
</script>


<style lang="scss">
.swiper{
	position: relative;
}
.swiper-button-prev{
	top:25% !important;
	width: 6.4rem !important;
	height: 6.4rem !important;
	background-image: url(../assets/img/home-zizhi-swiper-left.png) !important;
	background-size:6.4rem 6.4rem !important;
}
.swiper-button-next{
	top:25% !important;
	width: 6.4rem !important;
	height: 6.4rem !important;
	background-image: url(../assets/img/home-zizhi-swiper-right.png) !important;
	background-size:6.4rem 6.4rem !important;
}
.zizhi-grid {
	padding-top: 3%;
	.zizhi-title{
		margin-top: 2.5rem;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: 400;
		font-size: 1.6rem;
		color: #333333;
	}
}
.zizhi-img{
	width: 90%;
}
</style>